import { Component, Input } from "@angular/core";
import { EffectivenessModel } from "../../shared/models";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";
import { DateFormatPipe } from "@app/shared/pipes/date-format.pipe";

@Component({
    selector: "eff-detail-breadcrumb-info",
    templateUrl: "./eff-detail-breadcrumb-info.component.html",
    styleUrls: ["./eff-detail-breadcrumb-info.component.scss"],
    imports: [TranslatePipe, DateFormatPipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class EffDetailBreadcrumbInfoComponent {
    @Input() effectivenessModel: EffectivenessModel;
}
